import qs from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { EntityTypes } from 'context/entityContext';

interface ISearchURLArgs {
  entityType: EntityTypes;
  query?: string;
  limit?: number;
  showGrouped?: boolean;
  excludeNonSold?: string;
  releaseData?: string;
}

export default function getSearchURL(args: ISearchURLArgs): string {
  const {
    entityType,
    query,
    limit,
    showGrouped = true,
    excludeNonSold,
    releaseData,
  } = args;

  const type = entityTypeToApiType(entityType);

  const params = qs.stringify({
    limit,
    query,
    showGrouped,
    excludeNonSold,
    releaseData,
  });

  return `/api/search/${type}?${params}`;
}
